//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/ErrorList.js";
import "../no/PDM.js";
import "../no/ComponentReferenceCollector.js";
import "../no/DesignSessionBuilder.js";
import "../no/Session.js";
let d=[[],[[["referencePart"],"CreateDesignSession",{},1,0],[["databaseObject"],"OpenDesignSession",{},1,0],[["dmusessionPartTag","componentsToInclude"],"DesignSessionIncludeComponentsInRecipe",{},2,0],[["dmusessionPartTag","componentsToExclude"],"DesignSessionExcludeComponentsFromRecipe",{},2,0],[["databaseObject","componentReferenceCollector"],"OpenDesignSessionWithSelectedComponents",{},2,0],[[],"GetComponentReferenceCollector",{R_:{componentReferenceCollector:"ComponentReferenceCollector"}},0,0],[[],"CreateDesignSessionBuilder",{R_:{builder:"DesignSessionBuilder"}},0,0],[["dmusessionPartTag","componentsToExclude"],"ExcludeComponentsFromProductRecipe",{R_:{errors:"ErrorList"}},2,0],[["dmusessionPartTag","componentsToInclude"],"IncludeWithChildrenInProductRecipe",{R_:{errors:"ErrorList"}},2,0]],[]];
SPLM.DMUSessionCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DMUSessionCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;